import { courseDetailsSlot } from '@/features/catalog/courses/paths'
import { classDetailsSlot } from '@/features/classes/class-form/class'
import { enrollmentDetailsSlot } from '@/features/entitlements/enrollments/paths'
import { detailsSlots } from '@/shared/details'
import type { TabContribution } from '@/shared/registry'

import { skillsTabId } from './skills'

/**
 * The Skills tabs on Course, Class and Enrollment Details (CRD-14). `SkillsProvider` knows them by
 * their loaders, so it hides these and never another area's tab.
 */
export const skillTabs: readonly TabContribution[] = [
  {
    kind: 'tab',
    slot: detailsSlots(courseDetailsSlot).tabs,
    id: skillsTabId,
    labelId: 'credentials.skills.tab',
    component: () => import('./SkillsTab').then((module) => module.CourseSkillsTab),
  },
  {
    kind: 'tab',
    slot: detailsSlots(classDetailsSlot).tabs,
    id: skillsTabId,
    labelId: 'credentials.skills.tab',
    component: () => import('./SkillsTab').then((module) => module.ClassSkillsTab),
  },
  {
    kind: 'tab',
    slot: detailsSlots(enrollmentDetailsSlot).tabs,
    id: skillsTabId,
    labelId: 'credentials.skills.tab',
    component: () => import('./SkillsTab').then((module) => module.EnrollmentSkillsTab),
  },
]
